import React from 'react'

import SettingsPage from '../SettingsPage'
import Roles from './Roles'

const RolesPermissionsSettings = () => (
  <SettingsPage title={`Roles & Permissions`}>
    <Roles />
  </SettingsPage>
)

export default RolesPermissionsSettings
